module.exports = __webpack_public_path__ + "static/media/question-mark.b9d53d5e.svg";